import { Inline, Stack, breakpoints, vars } from '@etg/wings';
import { css, mediaQueries } from '@eti/styles';
import Media from 'react-media';
import Skeleton from '../../../../../common/components/Skeleton';

const boundStyles = css`
  padding: 24px 16px;

  &.resultTripCardLeft {
    border-right: 1px solid ${vars.colors.divider};
    width: 75%;
  }

  @media ${mediaQueries.medium.up} {
    border-bottom-left-radius: ${vars.card.borderRadius};
    border-top-left-radius: ${vars.card.borderRadius};

    &.resultTripCardRight {
      border-right: 1px solid #eee;
      justify-content: end;
      width: 25%;
    }
  }

  @media ${mediaQueries.small.only} {
    &.resultTripCardRight {
      align-items: end;
      width: 100%;

      > div {
        width: 50%;
      }
    }

    &.resultTripCardLeft {
      border-bottom: 1px solid #eee;
      border-right: 0;
      padding: 16px;
      width: 100%;

      > div:first-child {
        display: none;
      }
    }
  }
`;

const FlightResultSkeleton = () => (
  <Inline data-testid="flight-result-skeleton" spacing={0}>
    <Stack className={`${boundStyles} resultTripCardLeft`} spacing={32}>
      <Stack spacing={8}>
        <Skeleton.Box height={24} />
        <Skeleton.Box height={24} />
      </Stack>
      <Stack
        spacing={{
          [breakpoints._0]: 24,
          [breakpoints._768]: 8,
        }}
      >
        <Media query="(max-width: 767px)">
          {(matches) =>
            matches ? (
              <>
                <Skeleton.Box height={34} />
                <Skeleton.Box height={34} />
              </>
            ) : (
              <>
                <Skeleton.Box height={24} />
                <Skeleton.Box height={24} />
              </>
            )
          }
        </Media>
      </Stack>
    </Stack>
    <Stack className={`${boundStyles} resultTripCardRight`}>
      <Skeleton.Box height={40} />
    </Stack>
  </Inline>
);

export default FlightResultSkeleton;
